import { createMultiStyleConfigHelpers, ComponentStyleConfig } from '@chakra-ui/react';
import { numberInputAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(numberInputAnatomy.keys);

const baseStyle = definePartsStyle({
  root: {},
  field: {
    // I don't know why I have to duplicate these, but it doesn't work otherwise
    background: 'chakra-body-bg',
    bgColor: 'chakra-body-bg',
    border: '2px solid',
    borderWidth: '2px',
    borderRadius: 'lg'
  }
});

export const numberInputTheme: ComponentStyleConfig = defineMultiStyleConfig({
  baseStyle
});
